export const QA_NAME_GRETA_AI_CHAT_PROJECTS_PAGE_CARD =
  'gretaAIChatProjectsPageCard'
